import { MouseEventHandler } from 'react'
import { Button, SxProps } from '@mui/material'

import { SizingContainer } from 'components/SizingContainer'

interface AddAnotherButtonProps {
  text: string
  onClick: MouseEventHandler<HTMLButtonElement>
}

const style: SxProps = {
  display: 'block',
  margin: '0 auto',
}

export default function AddAnotherButton({ text, onClick }: AddAnotherButtonProps): JSX.Element {
  return (
    <SizingContainer size="large">
      <Button className="append-add-button" onClick={onClick} sx={style}>
        Add an {text}
      </Button>
    </SizingContainer>
  )
}
